<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" small :color="isGeolocated ? 'green' : 'red'">
        {{ isGeolocated ? "location_on" : "location_off" }}
      </v-icon>
    </template>
    <span>{{ isGeolocated ? "Geolocalizado" : "Sin geolocalizar" }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    subClient: Object,
  },
  computed: {
    isGeolocated() {
      return (
        this.subClient != null &&
        this.subClient.latitudAddress != null &&
        this.subClient.latitudAddress !== "" &&
        this.subClient.longitudAddress != null &&
        this.subClient.longitudAddress !== ""
      );
    },
  },
};
</script>
